import transformPt from './transform-pt.js';

function degToRad(degrees) {
	return degrees * (Math.PI / 180);
}

function rotatePoint(pt, rotation = 0) {
	const rot = degToRad(rotation % 360);
	const cos = Math.cos(rot);
	const sin = Math.sin(rot);
	return transformPt(pt, [cos, sin, -sin, cos, 0, 0]);
}

export default rotatePoint;
